export const getColorsOnBorder = (source, toMatchWith, complexMatch, chipMatch) => {
    let borderColor = "";
    
    if(!toMatchWith){
        borderColor = "var(--outlined)";
    } else if(!!complexMatch || !!chipMatch){
        borderColor = "1.5px solid green";
    } else if(source === 'jobMatch'){
        borderColor = "var(--outlined)";
    } else if(!complexMatch && !chipMatch){
        borderColor = "2px solid red";
    }
    
    return borderColor;
}